import axios from 'axios';

const instance = axios.create({
   //baseURL: 'http://localhost:3000/api/v1/'
   // baseURL: 'https://dev-api.blossomsfood.com.sg/api/v1/' // dev URL
    baseURL: 'https://orderapi.blossomsfood.com.sg/api/v1/' // LIVE URL

});

export default instance;